import { Callout as GammaCallout } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type CalloutProps = React.ComponentProps<typeof GammaCallout>

const Callout: React.FC<CalloutProps> = ({ removeLabel, ...props }) => (
  <GammaCallout {...props} removeLabel={removeLabel ?? i18n.t('common.close')} />
)

export default Callout
